import React from 'react';
import { motion } from 'framer-motion';
import BackToHomeLink from '../components/BackToHomeLink';

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-beige/10 pt-32 pb-20">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12 border border-brown/10"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <motion.h1
            className="text-3xl md:text-4xl font-bold text-brown mb-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Politique de Confidentialité
          </motion.h1>

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">1. Introduction</h2>
              <p>
                Cette politique de confidentialité s'applique au site : <strong>www.siriane-belliard.fr</strong>.
                La présente politique de confidentialité a pour but d'exposer aux utilisateurs du site :
              </p>
              <ul className="list-disc ml-8 mt-2 space-y-1">
                <li>La manière dont sont collectées et traitées leurs données à caractère personnel.</li>
                <li>Quels sont les droits des utilisateurs concernant ces données.</li>
                <li>Qui est responsable du traitement des données à caractère personnel collectées et traitées.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">2. Données collectées et finalités</h2>
              <p>
                Dans le cadre de votre utilisation du site, nous pouvons être amenés à collecter différentes données personnelles
                vous concernant pour les finalités suivantes :
              </p>
              <ul className="list-disc ml-8 mt-2 space-y-1">
                <li>Gestion des rendez-vous : nom, prénom, numéro de téléphone, adresse e-mail.</li>
                <li>Réponse à vos demandes de contact : nom, prénom, adresse e-mail, contenu de votre message.</li>
              </ul>
              <p className="mt-2">
                Aucune donnée de santé n'est collectée via le site internet. Les données médicales et de santé ne sont
                recueillies que lors des consultations en cabinet, dans le respect du secret médical.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">3. Base légale du traitement</h2>
              <p>
                Le traitement de vos données personnelles est justifié par différentes bases légales en fonction du contexte :
              </p>
              <ul className="list-disc ml-8 mt-2 space-y-1">
                <li>L'exécution du contrat lorsque vous prenez rendez-vous.</li>
                <li>Votre consentement pour le traitement des données à des fins de contact.</li>
                <li>L'intérêt légitime poursuivi par le cabinet lorsqu'il traite certaines données des patients pour améliorer ses services.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">4. Conservation des données</h2>
              <p>
                Les données à caractère personnel collectées sont conservées pour une durée n'excédant pas la durée nécessaire
                aux finalités pour lesquelles elles sont collectées et traitées.
              </p>
              <p className="mt-2">
                Les données relatives aux patients sont conservées conformément aux délais légaux applicables aux dossiers médicaux.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">5. Droits des utilisateurs</h2>
              <p>
                Conformément à la réglementation concernant le traitement des données à caractère personnel, l'utilisateur possède les droits suivants :
              </p>
              <ul className="list-disc ml-8 mt-2 space-y-1">
                <li>Droit d'accès, de rectification et de suppression des données.</li>
                <li>Droit à la limitation du traitement des données.</li>
                <li>Droit d'opposition au traitement des données.</li>
                <li>Droit à la portabilité des données.</li>
              </ul>
              <p className="mt-2">
                Vous pouvez exercer ces droits en contactant : <strong>neuro.endo.therapeute@gmail.com</strong>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">6. Sécurité des données</h2>
              <p>
                Le cabinet prend toutes les précautions utiles pour préserver la sécurité de vos données et notamment,
                empêcher qu'elles soient déformées, endommagées ou que des tiers non autorisés y aient accès.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">7. Cookies</h2>
              <p>
                Le site peut utiliser des cookies techniques strictement nécessaires à son fonctionnement.
                Ces cookies ne collectent aucune donnée personnelle et ne sont pas utilisés à des fins publicitaires.
              </p>
            </section>
          </div>

          <motion.div
            className="mt-12 flex justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            <BackToHomeLink variant="solid" />
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
